import { useEffect, useState } from "react";
import ConfigurationService from "../../services/ConfigurationService";

let configurationDetailInitial = {
    id: "",
    agente_capacitador: "",
}

function createData(response) {

    if (response == null) return null;

    return {
        id: response.id,
        agente_capacitador: response.agente_capacitador,
    };
}

const useConfiguration = () => {
    const [loading, setLoading] = useState(true);
    const [configurationDetail, setConfigurationDetail] = useState(configurationDetailInitial);
    const [originalDataChanged, setOriginalDataChanged] = useState(false);
    const [updateSuccess, setUpdateSuccess] = useState(false);
    const [updateFailure, setUpdateFailure] = useState(false);

    useEffect(() => {
        checkDataChanged();
    }, [configurationDetail])

    // region state updates

    const updateAgenteCapacitador = (agente_capacitador) => {
        const newData = {
            ...configurationDetail,
            agente_capacitador: agente_capacitador,
        }
        setConfigurationDetail(newData);
    };

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setUpdateSuccess(false);
        setUpdateFailure(false);
    };

    const checkDataChanged = () => {
        const hasChanged = JSON.stringify(configurationDetailInitial) != JSON.stringify(configurationDetail);
        setOriginalDataChanged(hasChanged)
    }

    // region service calls

    const getConfiguration = async () => {
        const response = await ConfigurationService.getConfigurations();
        const existing = response && response.length > 0 ? response[0] : null;
        const configurationData = createData(existing) ?? configurationDetailInitial;
        configurationDetailInitial = JSON.parse(JSON.stringify(configurationData));
        setConfigurationDetail(configurationData);
        setLoading(false);
    };

    // end region

    const saveConfiguration = async () => {
        const response = configurationDetail.id
            ? await ConfigurationService.updateConfiguration(configurationDetail.id, configurationDetail)
            : await ConfigurationService.createConfiguration(configurationDetail);
        if (response) {
            setUpdateSuccess(true);
            const configurationData = createData(response);
            configurationDetailInitial = { ...configurationData }
            setConfigurationDetail(configurationData);
        } else {
            setUpdateFailure(true);
        }
    };

    return {
        loading,
        configurationDetail,
        getConfiguration,
        updateAgenteCapacitador,
        updateSuccess,
        updateFailure,
        originalDataChanged,
        handleClose,
        saveConfiguration,
    }
};

export default useConfiguration;
